import {http} from "@/assets/utils/api";

export const getCourseQuestion = (params) => http.get('/yymCourseVideoQuestion/list',{params});

/**
 * ai问答获取SSE流的id
 */
export const getSSEId = (params) => http.get('/smarts/sse/connect',{params});

/**
 * 问答列表
 */
export const getQuestionList = (params) => http.get('/smarts/page',{params});